import { apiSlice } from "../api/apiSlice";
export const quizeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuize: builder.query({
      query: (video_id) => ({
        url: `/quizzes/?video_id=${video_id}`,
        method: "GET",
      }),
      providesTags: ["Quize"],
    }),
    getAllQuize: builder.query({
      query: () => ({
        url: "/quizzes",
        method: "GET",
      }),
      providesTags: ["Quizes"],
    }),
    getSingleQuize: builder.query({
      query: (id) => ({
        url: `/quizzes/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, arg) => [{ type: "Quize", id: arg }],
    }),

    addQuize: builder.mutation({
      query: (data) => ({
        url: "/quizzes",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Quize", "Quizes"],
    }),
    deleteQuize: builder.mutation({
      query: (id) => ({
        url: `/quizzes/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Quize", "Quizes"],
    }),
    editQuize: builder.mutation({
      query: ({ id, data }) => ({
        url: `/quizzes/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Quize", "Quizes"],
    }),
  }),
});

export const {
  useGetQuizeQuery,
  useGetAllQuizeQuery,
  useAddQuizeMutation,
  useEditQuizeMutation,
  useDeleteQuizeMutation,
  useGetSingleQuizeQuery,
} = quizeApi;
